import styled from '@emotion/styled';
import colours from '~/utils/colours';

const PanelSection = styled.div`
  padding-bottom: 12px;
  border-bottom: 1px solid ${colours.greyLightAlt8};
  margin-bottom: 12px;
`;

export default PanelSection;
